// Identifiants et liens de campagne pour la promo de l'app mobile (DIFF-A5).
//
// Les URL ci-dessous sont GÉNÉRÉES par le script `lien_campagne.py` du projet
// Webflow (à partir de sa nomenclature `nomenclature-campagnes.yaml`) — elles ne
// vivent pas dans ce repo. Ne JAMAIS les composer à la main : un nouvel
// emplacement doit d'abord être déclaré côté nomenclature, puis regénéré.
// C'est pourquoi l'id App Store n'est pas interpolé dans ces URL : on les
// recopie telles que le script les sort.
export const APP_STORE_ID = '6783846191';

// Smart App Banner iOS — même balise sur toutes les pages qui la portent.
export const APPLE_ITUNES_APP_META = {
  name: 'apple-itunes-app',
  content: `app-id=${APP_STORE_ID}`,
};

const APP_LINKS = {
  confirm: {
    ios:
      'https://apps.apple.com/fr/app/apple-store/id6783846191?pt=127123147&ct=app-launch_site_confirm&mt=8',
    android:
      'https://play.google.com/store/apps/details?id=com.roulezjeunesse&referrer=utm_source%3Dsite%26utm_medium%3Dreferral%26utm_campaign%3Dapp-launch%26utm_content%3Dconfirm',
  },
  compte: {
    ios:
      'https://apps.apple.com/fr/app/apple-store/id6783846191?pt=127123147&ct=app-launch_site_compte&mt=8',
    android:
      'https://play.google.com/store/apps/details?id=com.roulezjeunesse&referrer=utm_source%3Dsite%26utm_medium%3Dreferral%26utm_campaign%3Dapp-launch%26utm_content%3Dcompte',
  },
  histo: {
    ios:
      'https://apps.apple.com/fr/app/apple-store/id6783846191?pt=127123147&ct=app-launch_site_histo&mt=8',
    android:
      'https://play.google.com/store/apps/details?id=com.roulezjeunesse&referrer=utm_source%3Dsite%26utm_medium%3Dreferral%26utm_campaign%3Dapp-launch%26utm_content%3Dhisto',
  },
};

export default APP_LINKS;
